import React from "react";
import {SortableElement} from "react-sortable-hoc";

class RepeaterSortableElement extends React.Component {

    render() {
        return this.props.children;
    }

}

export default SortableElement(RepeaterSortableElement);
